import React, { createContext, ReactNode, useContext, useState } from "react";

interface TargetGroupContextValue {
  isSidebarOpen: boolean;
  showSidebar: () => void;
  hideSidebar: () => void;
  toggleSidebar: () => void;
  setIsSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const TargetGroupContext = createContext<TargetGroupContextValue | undefined>(
  undefined,
);

interface TargetGroupProviderProps {
  children: ReactNode;
}

export const TargetGroupProvider: React.FC<TargetGroupProviderProps> = ({
  children,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const showSidebar = () => setIsSidebarOpen(true);
  const hideSidebar = () => setIsSidebarOpen(false);
  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  const value: TargetGroupContextValue = {
    isSidebarOpen,
    showSidebar,
    hideSidebar,
    toggleSidebar,
    setIsSidebarOpen,
  };

  return (
    <TargetGroupContext.Provider value={value}>
      {children}
    </TargetGroupContext.Provider>
  );
};

export const useTargetGroup = (): TargetGroupContextValue => {
  const context = useContext(TargetGroupContext);
  if (context === undefined) {
    throw new Error("useTargetGroup must be used within a TargetGroupProvider");
  }
  return context;
};
